import { Box, Chip, styled } from '@mui/material'
import { IMediaDelivery, EMediaDeliveryStatus } from '@shared/Types'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid'
import CreateStatusCell, { TStatusCellConfig } from '@shared/UIStyleds/create.status-cell'

export const StatusCellConfigs: TStatusCellConfig<EMediaDeliveryStatus> = {
  Pending: { background: 'linear-gradient(to right,#0090ff,#88c9ff)' },
  Processing: { background: 'linear-gradient(to right,#0d6efd,#82baff)' },
  Rejected: { background: 'linear-gradient(to right,#e72134,#eba1a1)' },
  Done: { background: 'linear-gradient(to right,#357a38,#1edd9b)' }
}

export const UIStatusCell = CreateStatusCell<EMediaDeliveryStatus>(StatusCellConfigs, { sx: { minWidth: '90px' } })

export const renderCellTypeChips = () => {
  return function func(tableRow: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) {
    const data = tableRow.row as IMediaDelivery
    const list = [data.ContentType, data.MediaType]
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', height: '100%' }}>
        {list.map((x, i) => (
          <CustomChip key={'key' + i} label={x} size='small' />
        ))}
      </Box>
    )
  }
}

const CustomChip = styled(Chip)({
  fontStyle: 'italic',
  color: '#606060',
  fontSize: '11px',
  fontWeight: 600
})
